import { Layout } from 'lucide-react';
import { GuideCategory } from './types';

export const studioInterfaceGuide: GuideCategory = {
  id: 'studio-interface',
  title: 'Using the Studio',
  icon: Layout,
  articles: [
    {
      slug: 'navigating-studio',
      title: 'Navigating the Ball Engine',
      description: 'A simple guide to the ball bouncing simulator interface.',
      sections: [
        {
          id: 'sidebar-controls',
          title: 'The Settings Sidebar',
          content: 'The left sidebar is where you control the ball engine. You\'ll find tabs for Physics, Visuals, and Audio. Each tab lets you tweak the ball physics simulations in real-time.',
          settingId: 'studio_sidebar_navigation'
        },
        {
          id: 'tab-system',
          title: 'Understanding Tabs',
          content: 'Switch between "Physics" to change how balls move, "Visuals" to change colors and effects, and "Audio" to manage your track. Each tab is designed to be intuitive and fast.',
          settingId: 'studio_tabs_overview'
        },
        {
          id: 'playback-controls',
          title: 'Controlling Simulation Time',
          content: 'Use the playback controls at the top to start, pause, or reset your ball bouncing simulation. This allows you to time your recordings perfectly with your audio.',
          tips: ['Press Spacebar for a quick Play/Pause toggle.']
        },
        {
          id: 'hud-toggles',
          title: 'The Interface HUD',
          content: 'You can toggle the visibility of the interface (HUD) to get a clean view of your simulation during playback.',
          settingId: 'hud_toggle_button'
        }
      ]
    },
    {
      slug: 'project-workflow',
      title: 'Managing Your Projects',
      description: 'How to save, load, and organize your ball simulations.',
      sections: [
        {
          id: 'saving-presets',
          title: 'Cloud Saved Presets',
          content: 'Created a unique ball physics configuration? Save it as a preset so you can reload your specific ball engine setup any time. Presets are stored in your account.',
          settingId: 'save_preset_button'
        },
        {
          id: 'loading-presets',
          title: 'Loading Creations',
          content: 'Access your library of saved simulations from the "My Projects" tab. You can instantly restore all settings, including audio and visual choices.',
          settingId: 'load_preset_list'
        },
        {
          id: 'auto-save',
          title: 'Local Auto-Save',
          content: 'The studio periodically saves your current working state locally in your browser to prevent data loss if you refresh the page.',
          tips: ['Always use Cloud Save for your final versions to ensure they are backed up safely.']
        }
      ]
    },
    {
      slug: 'exporting-videos',
      title: 'Recording & Exporting',
      description: 'How to capture your ball simulations in high quality for social media.',
      sections: [
        {
          id: 'recording-process',
          title: 'High-Quality Recording',
          content: 'Hit the record button to capture your ball bouncing simulator. Our recorder captures everything in high definition, ready for your next viral post.',
          tips: ['Make sure your audio is playing at the right volume before hitting record!']
        },
        {
          id: 'export-formats',
          title: 'Export Formats',
          content: 'Download your recording as a .webm or .mp4 file. These formats are highly compressed but maintain great visual quality for mobile sharing.',
          settingId: 'export_format_dropdown'
        },
        {
          id: 'cloud-rendering-basics',
          title: 'Cloud Render Option',
          content: 'If your local device is struggling with complex simulations, use our Cloud Render service to generate perfect 60FPS videos on our servers.',
          tips: ['Cloud rendering is recommended for simulations with thousands of balls.']
        }
      ]
    }
  ]
};
